import { render, staticRenderFns } from "./DialogTemplateEmailPreview.vue?vue&type=template&id=e327a4d4&"
import script from "./DialogTemplateEmailPreview.vue?vue&type=script&lang=js&"
export * from "./DialogTemplateEmailPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports